module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABsAAAAYCAYAAAALQIb7AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAABlSURBVHgB7dLBDYAgDAXQNnEAR2AVN3AzR9ANnMUJyib1E/FCuAEn/kt+OJHfJhUhIiq5e0CO9MpoKLn8Y8ML82Y2b6HWPkibgNzIikRkU9UolaLT+7N/gaXoe/I0vaVr3YVoTi/0f7QL/zryXgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Left.png
// module id = ebiI
// module chunks = 1